<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h4 class="mt-4">Calculadora de custos</h4>
      </div>

      <div class="col-5 mt-2">
        <label>Quantidade de itens:</label>
        <input type="number" class="form-control" v-model="qtd" placeholder="0">
      </div>

      <div class="col-5 mt-2">
        <label>Valor total vendido:</label>
        <input
          type="text"
          class="form-control"
          v-model="valor"
          placeholder="R$ 0,00"
          v-money="money"
        >
      </div>

      <div class="col-2 mt-2 align-self-end ml-auto">
        <button
          class="btn btn-success btn-block"
          @click="qtd = null, valor = null"
        >Limpar</button>
      </div>

      <div class="col-12 mt-1">
        <table class="table table-bordered table-hover">
          <thead class="thead-dark">
            <tr>
              <th scope="col">Empresas</th>
              <th scope="col" class="text-center">Taxas</th>
              <th scope="col" class="text-center">Custo por item</th>
              <th scope="col" class="text-center">Valor a pagar (itens)</th>
              <th scope="col" class="text-center">Comissão</th>
              <th scope="col" class="text-center">Valor total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <img src="https://logodownload.org/wp-content/uploads/2016/08/mercado-livre-logo-8.png" width="75" alt="Mercado Livre">
              </td>
              <td class="text-center">{{ comissao.ml }}%</td>
              <td class="text-center">{{ formatarValor(item.ml) }}</td>
              <td class="text-center">{{ qtd == null ? 'R$ 0,00' : valorItens(item.ml) }}</td>
              <td class="text-center">{{ valor == null ? 'R$ 0,00' : valorComissao(comissao.ml) }}</td>
              <td class="text-center">{{ valor == null || qtd == null ? 'R$ 0,00' : valorTotal(item.ml, comissao.ml) }}</td>
            </tr>
            <tr>
              <td>
                <img src="https://logodownload.org/wp-content/uploads/2021/03/shopee-logo-4.png" width="75" alt="Shoppe">
              </td>
              <td class="text-center">{{ comissao.shoppe }}%</td>
              <td class="text-center">{{ formatarValor(item.shoppe) }}</td>
              <td class="text-center">{{ qtd == null ? 'R$ 0,00' : valorItens(item.shoppe) }}</td>
              <td class="text-center">{{ valor == null ? 'R$ 0,00' : valorComissao(comissao.shoppe) }}</td>
              <td class="text-center">{{ valor == null || qtd == null ? 'R$ 0,00' : valorTotal(item.shoppe, comissao.shoppe) }}</td>
            </tr>
            <tr>
              <td>
                <img src="https://www.meta.com.br/wp-content/uploads/2022/05/Logo-Olist.png" width="50" alt="Olist">
              </td>
              <td class="text-center">{{ comissao.olist }}%</td>
              <td class="text-center">{{ formatarValor(item.olist) }}</td>
              <td class="text-center">{{ qtd == null ? 'R$ 0,00' : valorItens(item.olist) }}</td>
              <td class="text-center">{{ valor == null ? 'R$ 0,00' : valorComissao(comissao.olist) }}</td>
              <td class="text-center">{{ valor == null || qtd == null ? 'R$ 0,00' : valorTotal(item.olist, comissao.olist) }}</td>
            </tr>
            <tr>
              <td>
                <img src="https://logodownload.org/wp-content/uploads/2014/06/magalu-logo-6.png" width="125" alt="Magazine Luiza">
              </td>
              <td class="text-center">{{comissao.luiza}}%</td>
              <td class="text-center">{{formatarValor(item.luiza)}}</td>
              <td class="text-center">{{ qtd == null ? 'R$ 0,00' : valorItens(item.luiza) }}</td>
              <td class="text-center">{{ valor == null ? 'R$ 0,00' : valorComissao(comissao.luiza) }}</td>
              <td class="text-center">{{ valor == null || qtd == null ? 'R$ 0,00' : valorTotal(item.luiza, comissao.luiza) }}</td>
            </tr>
            <tr>
              <td>
                <img src="https://logodownload.org/wp-content/uploads/2019/10/americanas-logo-1.png" width="115" alt="Americanas">
              </td>
              <td class="text-center">{{ comissao.ame }}%</td>
              <td class="text-center">{{ formatarValor(item.ame) }}</td>
              <td class="text-center">{{ qtd == null ? 'R$ 0,00' : valorItens(item.ame) }}</td>
              <td class="text-center">{{ valor == null ? 'R$ 0,00' : valorComissao(comissao.ame) }}</td>
              <td class="text-center">{{ valor == null || qtd == null ? 'R$ 0,00' : valorTotal(item.ame, comissao.ame) }}</td>
            </tr>
            <tr>
              <td>
                <img src="https://logodownload.org/wp-content/uploads/2014/04/amazon-logo.png" width="75" alt="Amazon">
              </td>
              <td class="text-center">{{ comissao.amazon }}%</td>
              <td class="text-center">{{ formatarValor(item.amazon) }}</td>
              <td class="text-center">{{ qtd == null ? 'R$ 0,00' : valorItens(item.amazon) }}</td>
              <td class="text-center">{{ valor == null ? 'R$ 0,00' : valorComissao(comissao.amazon) }}</td>
              <td class="text-center">{{ valor == null || qtd == null ? 'R$ 0,00' : valorTotal(item.amazon, comissao.amazon) }}</td>
            </tr>
            <tr class="bg-table">
              <td>
                <img src="https://construp.com.br/img/Logo Novo ConstrUp.png" width="95" alt="Constr Up">
              </td>
              <td class="text-center">{{ comissao.construp }}%</td>
              <td class="text-center">{{ formatarValor(item.construp) }}</td>
              <td class="text-center">{{ qtd == null ? 'R$ 0,00' : valorItens(item.construp) }}</td>
              <td class="text-center">{{ valor == null ? 'R$ 0,00' : valorComissao(comissao.construp) }}</td>
              <td class="text-center">{{ valor == null || qtd == null ? 'R$ 0,00' : valorTotal(item.construp, comissao.construp) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
        <span
          class="c-orange">
          * Pagamento mínimo mensal de {{ planosApp[0].preco }} descontado da comissão.
        </span>
  </div>
</template>

<script>

export default {
  name: 'CalcCustos',
  data() {
    return {
      qtd: null,
      valor: null,
      item: {
        ml: 5.50,
        shoppe: 2.00,
        olist: 5.00,
        luiza: 3.00,
        ame: 5.00,
        amazon: 2.00,
        construp: 0,
      },
      comissao: {
        ml: 19,
        shoppe: 20,
        olist: 21,
        luiza: 20,
        ame: 19,
        amazon: 15,
        construp: 4,
      },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      planosApp: '',
    };
  },
  created() {
    this.showPlanos();
  },
  methods: {
    formatarValor(valor) {
      return valor.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    },
    valorItens(item) {
      var total = item * this.qtd;
      return this.formatarValor(total);
    },
    valorTotal(item, comissao) {
      if(this.valor == null) {
        return 'R$ 0,00';
      }

      var qtd = item * this.qtd;

      var valorString = this.valor;
      var valorNumerico = valorString.replace("R$", "").replace(",", "").replace(".", "").replace(".", "").replace(".", "");

      var resultado = (comissao / 100) * (valorNumerico / 100);
      var total = resultado + qtd;

      return this.formatarValor(total);
    },
    valorComissao(comissao) {
      if(this.valor == null) {
        return 'R$ 0,00';
      }

      var valorString = this.valor;
      var valorNumerico = valorString.replace("R$", "").replace(",", "").replace(".", "").replace(".", "").replace(".", "");

      var resultado = (comissao / 100) * (valorNumerico / 100);
      return this.formatarValor(resultado); 
    },
    showPlanos() {
      this.$store.dispatch('startLoader');
      this.$store.dispatch('admin/showPlanosApp')
      .then((response) => {
        this.planosApp = response.data;
        this.$store.dispatch('endLoader');
      })
    },
  },
};
</script>
<style scoped>
  .bg-table {
    background: rgb(242, 239, 239);
  }
</style>
